<template>
    <div class="stream-prop">
        <span class="stream-prop__label mr-2">Объект:</span>

        <TaskObject
            v-if="isAccessAllow"
            :activeId="activeId"
            @setActive="setActive"
        />

        <span v-else>{{this.stream.description_object?.name || 'не задан'}}</span>
    </div>
</template>

<script>
import {mapState} from "vuex";
import TaskObject from "@/vue/plan/url/Task/TaskObject";

export default {
    name: "StreamObject",
    components: {TaskObject},
    props: ['isAccessAllow'],
    computed: {
        ...mapState({
            stream: state => state.planUrl.selectedStream,
        }),
        activeId() {
            return this.stream.description_object?.id || null;
        },
    },
    methods: {
        setActive(objectId) {
            this.$store.dispatch('updatePlanUrlStream', {
                streamId: this.stream.id,
                field: 'description_object_id',
                value: objectId,
            });
        },
    }
}
</script>
